import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewContentComponent } from './preview-content/preview-content.component';
import { HeaderModule, StorethemesModule } from '@urbannex/storethemes';
import { NbActionsModule, NbIconModule, NbLayoutModule, NbMenuModule, NbSidebarModule, NbThemeModule, NbThemeService } from '@nebular/theme';
import { EditorsModule } from '../editors/editors.module';
import { LayoutEditorService } from '../editors/layout-editor/layout-editor.service';
import { RenderPreviewSectionsComponent } from './render-preview-sections/render-preview-sections.component';
import { DynamicSectionRendererDirective } from './render-preview-sections/dynamic-section-renderer.directive';
import { PreviewSectionComponent } from './render-preview-sections/preview-section/preview-section.component';
import { SectionAttributesDirective } from './render-preview-sections/preview-section/section-attributes.directive';


@NgModule({
  declarations: [PreviewContentComponent, RenderPreviewSectionsComponent, DynamicSectionRendererDirective, PreviewSectionComponent, SectionAttributesDirective],
  imports: [
    CommonModule,
    StorethemesModule,
    NbLayoutModule,
    NbThemeModule.forRoot({name:'default'}),
    NbSidebarModule,
    NbMenuModule,
    NbIconModule,
    NbActionsModule,
    HeaderModule,
    EditorsModule
  ],
  exports:[PreviewContentComponent,RenderPreviewSectionsComponent,PreviewSectionComponent,SectionAttributesDirective]
})
export class PreviewModule { }
